// Every domain the admin/presenter site needs lives here - nothing else hard-codes a URL.
//
// Values come from (first match wins):
//   1. window.__ENV__  - written at container start from the container's environment into /env.js,
//                        so changing a domain is just an env change + restart (no rebuild)
//   2. REACT_APP_*     - build-time / `npm start` (frontend/.env.development.local)
//   3. a safe default
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

const clean = (v) => (typeof v === 'string' ? v.trim() : '');
const pick = (...values) => values.map(clean).find(Boolean) || '';
const noSlash = (s) => s.replace(/\/+$/, '');
const withSlash = (s) => (s.endsWith('/') ? s : s + '/');

// The API (e.g. https://api.example.com)
export const API_URL = noSlash(pick(runtime.API_URL, process.env.REACT_APP_BACKEND_URL));

// The websocket server (e.g. wss://live.example.com)
export const LIVE_URL = noSlash(pick(runtime.LIVE_URL, process.env.REACT_APP_LIVE_URL, 'wss://live.myactivityhub.net'));

// Where players open the PHONE app. Shown on the presenter screen as the QR code / link.
export const APP_URL = noSlash(pick(runtime.APP_URL, process.env.REACT_APP_APP_URL, 'https://app.myactivityhub.net'));

// This admin site's public address. The bots open `${ADMIN_URL}/present/:id` on their screen share,
// so it must be reachable from the internet in production. Defaults to wherever you are browsing.
export const ADMIN_URL = noSlash(pick(runtime.ADMIN_URL, process.env.REACT_APP_ADMIN_URL, window.location.origin));

// Public base URL of the uploaded-files bucket (always ends with "/")
export const DATA_BUCKET_URL = withSlash(
	pick(runtime.DATA_BUCKET_URL, process.env.REACT_APP_DATA_BUCKET, 'https://myactivityhub-data.s3.eu-west-2.amazonaws.com/')
);
